import { useNavigate } from 'react-router-dom';
import { InlineLoading } from '@carbon/react';

import { useIsReadonly } from 'core/readonly';
import { routes } from 'core/routing';
import ActionButton from 'shared/components/ActionButton';
import FormActions from 'shared/components/FormActions';

const ProjectFormActions = ({
  projectId,
  primaryText = 'Save Changes',
  secondaryText,
  isPrimaryLoading,
  onPrimaryClick,
  onSecondaryClick,
  isLoading
}) => {
  const navigate = useNavigate();

  const isReadonly = useIsReadonly();

  return (
    <FormActions sticky>
      {secondaryText && (
        <ActionButton size="sm" onClick={onSecondaryClick} disabled={isLoading}>
          {secondaryText}
        </ActionButton>
      )}
      {isReadonly ? null : isPrimaryLoading ? (
        <InlineLoading description="Saving changes" status="active" aria-live="assertive" />
      ) : (
        <ActionButton size="sm" type="submit" disabled={isLoading} onClick={onPrimaryClick}>
          {primaryText}
        </ActionButton>
      )}
      {projectId && (
        <ActionButton size="sm" onClick={() => navigate(routes.projectOutputs(projectId))}>
          View Outputs
        </ActionButton>
      )}
    </FormActions>
  );
};

export default ProjectFormActions;
